<template>
    <footer >
     <div class="container" v-if="this.dataLoaded">
        <div class="row">
        <div class="col-sm-12 col-lg-2">
             <img src="./../assets/logo.png" width="150" height="auto" alt="">
        </div>
        <div class="col-sm-12 col-lg-10">
          <h1 v-if="this.currentLang == 'it'"><span>Tudor Nicolaou</span><br> Studio Legale Associato</h1>
          <h1 v-if="this.currentLang == 'en'"><span>Tudor Nicolaou</span><br> Law Firm</h1>
          <div class="row" >
            <div class="col-sm-12 col-lg-4">
              <p>{{this.firstSede.attributes.field_indirizzo_via}}</p>
              <p>Cod. Fisc. e P. IVA 01109190320</p>
              <p>
                <span v-if="this.currentLang == 'it'">Codice SDI:</span>
                <span v-else>Recipient Code</span>
                SUBM70N</p>
              <p>Tel. {{this.firstSede.attributes.field_telefono}}</p>
            </div>
            <div class="col-sm-12 col-lg-8">
              <p v-if="this.currentLang == 'it'">Polizza ass. a garanzia dei rischi professionali n. 450313564 e n. 450954209 sottoscritta con Assicurazioni Generali Ordine degli Avvocati di Trieste, Foro Ulpiano 1</p>
              <p v-if="this.currentLang == 'en'">Professional liability insurance policies n. 450313564 and n. 450954209 – Assicurazioni Generali Bar Association of Trieste, Foro Ulpiano 1</p>
            </div>
          </div>
          <div class="row mails">
            <div class="col-md-12 col-lg">
              <p><a :href="'mailto:' + this.firstSede.attributes.field_e_mail">{{this.firstSede.attributes.field_e_mail}}</a></p>
            </div>
            <div class="col-md-12 col-lg">
              <p><a :href="'mailto:' + this.firstSede.attributes.field_e_mail_certificata">{{this.firstSede.attributes.field_e_mail_certificata}}</a></p>
            </div>
            <div class="col-md-12 col-lg">
              <a @click="goToPrivacy()">Privacy Policy</a>
            </div>
            <div class="col-md-12 col-lg">
              <a @click="goToCookie()">Cookie Policy</a>
            </div>
          </div>
        </div>
        </div>
      </div> 
      <div class="col-md-12 col-lg-3">
      </div>
    </footer>
</template>

<script>
import Sedi from './Sedi.vue';

export default {
  name: 'my-footer',
  components:{
    Sedi
  },
  props: {
  },
  data:()=>{
    return {
      page:[],
      dataLoaded:false,
      firstSede:[],
      currentLang:"",
    }
  },
  methods:{
    goToCookie(){
      //this.$router.push({ name: 'cookie', params: { lang: "it" } })
      this.$router.push({ name: 'cookie'})
    },
    goToPrivacy(){
      this.$router.push({ name: 'privacy'})
    },
  },
  mounted(){

this.currentLang =  this.$route.params.lang;

          fetch("https://ptnlex-api-prod.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/sedi", {method: "GET", mode: 'cors'})
        .then(response=>{
            return response.json()
        })
        .then(json=>{
            this.firstSede = json.data[0]
            this.dataLoaded = true
        })
        .catch(function(error) {  
            console.log('Request failed', error)  
        });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
footer {
  padding: 2rem 0;
  background: #14182E;

  padding: 2rem 0;
  background: #14182E;

  h1,h2,h3,a,a:not([href]):not([class]){
    color: #fff;
  }
  p{
    color: #8C8A8E;
    font-size: 0.75rem;
    margin-bottom: 0;
  }
  a {
    cursor: pointer;
    font-size: 0.8125rem;
    &:hover {
      color: #F04533;
    }
  }
  h1 {
    color: #A6ADB7;
    font-size: 1.875rem;
    line-height: 2.4rem;
    margin-bottom: 2rem;
    span {
      color: #fff;
    }
  }
  .mails {
    border-top: 1px solid #70707047;
    padding: 1.4rem 0rem 0rem 0rem;
    margin-top:  1.4rem;
  }
  
}
@media (max-width: 768px){
   footer h1{
      font-size: 1.575rem;
      line-height: 2.1rem;
    }
}
</style>
